import { NgModule, Optional, SkipSelf } from '@angular/core';
// import { throwIfAlreadyLoaded } from './module-import-guard';
import { HttpService } from './services/http';
import { SnackBarService } from './services/snackbar.service';
import { NzNotificationModule } from 'ng-zorro-antd/notification';
import { UtilService } from './services/util.service';

const providers = [HttpService, SnackBarService, UtilService];
@NgModule({
    imports: [NzNotificationModule],
    providers: [...providers],
})
export class CoreModule {
    // constructor(@Optional() @SkipSelf() parentModule: CoreModule) {
    //     throwIfAlreadyLoaded(parentModule, 'CoreModule');
    // }
}
